import styled from 'styled-components';
import { zIndex } from 'tokens';

export const Base = styled.div`
	margin: 20px 16px;
	flex-shrink: 0;
	position: relative;
`;

export const Popover = styled.div`
	position: absolute;
	top: calc(100% + 6px);
	left: 0;
	right: 0;
	padding: 6px;
	background: ${(p) => p.theme.gray[100]};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 10px;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.24);
	z-index: ${zIndex.panelOverlay};
`;

export const Divider = styled.div`
	height: 1px;
	margin: 5px 10px;
	background: ${(p) => p.theme.gray[200]};
`;

// One menu, one grammar: every row is a non-interactive container holding two
// sibling buttons — the main action filling the row, and the open-in-new-tab
// control in a shared right-hand slot. Siblings, never nested, so each is a
// real <button> and its own tab stop.
export const RichRow = styled.div`
	position: relative;
	border-radius: 7px;
	transition: background-color 0.12s ease;

	&:hover {
		background-color: ${(p) => p.theme.gray[200]};
	}
`;

export const PlainRow = styled(RichRow)``;

export const IconCol = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 17px;
	flex-shrink: 0;
`;

const mainAction = `
	display: flex;
	width: 100%;
	border: none;
	background: transparent;
	text-align: left;
	font-family: inherit;
	border-radius: 7px;
	padding: 0 36px 0 10px;
	gap: 10px;
`;

export const RichMain = styled.button`
	${mainAction}
	align-items: flex-start;
	padding-top: 8px;
	padding-bottom: 9px;

	${IconCol} {
		height: 16px;
		margin-top: 1px;
	}
`;

export const RichText = styled.span`
	display: flex;
	flex-direction: column;
	gap: 2px;
	min-width: 0;
`;

export const RichTitle = styled.span`
	font-size: 13px;
	font-weight: 600;
	line-height: 1.25;
	color: ${(p) => p.theme.gray[1000]};
`;

export const RichSub = styled.span`
	font-size: 11px;
	line-height: 1.4;
	color: ${(p) => p.theme.gray[600]};
`;

export const PlainMain = styled.button`
	${mainAction}
	align-items: center;
	height: 34px;
	font-size: 13px;
	font-weight: 400;
	color: ${(p) => p.theme.gray[800]};

	&:hover:not([disabled]) {
		color: ${(p) => p.theme.gray[1000]};
	}

	&:disabled {
		opacity: 0.5;
	}
`;

// Revealed on row hover for every row, so "opens elsewhere" is one consistent
// gesture across the whole menu
export const NewTabButton = styled.button`
	position: absolute;
	top: 50%;
	right: 7px;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	border: none;
	border-radius: 6px;
	background: transparent;
	opacity: 0;
	transition: opacity 0.12s ease, background-color 0.12s ease;

	${RichRow}:hover &,
	&:focus-visible {
		opacity: 1;
	}

	&:hover {
		background-color: ${(p) => p.theme.gray[0]};
	}
`;
